import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export function useFetch(path, params) {
  const { version } = useApp();
  const [data, setData] = useState(null);
  const key = JSON.stringify(params || {});

  useEffect(() => {
    let alive = true;
    api
      .get(path, { params: JSON.parse(key) })
      .then((r) => alive && setData(r.data))
      .catch(() => alive && setData((d) => d ?? (/\/projects\/|\/sales\/companies\/[^/]+$/.test(path) ? false : [])));
    return () => {
      alive = false;
    };
  }, [path, key, version]);

  return data;
}
